/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sym-lookup[_ngcontent-%COMP%]   .sym-dropdown-menu[_ngcontent-%COMP%]{background-clip:border-box;max-height:250px;min-width:330px;overflow-y:auto}.sym-lookup[_ngcontent-%COMP%]   .sym-dropdown-menu[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]{padding-right:5px;padding-left:.3rem!important}.icon.sym-match[_ngcontent-%COMP%]{color:#6bdea1}.icon.sym-no-match[_ngcontent-%COMP%]{color:#ced4da}"];
export { styles as styles };
